/**
 * @desc 报损审核明细导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.storageReportDamage.damageDetailExcel.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/storageReportDamage/damageDetailExcel`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
